import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import CollectionHorizontal from "./CollectionHorizontal";
import CollectionVertical from "./CollectionVertical";
import CollectionList from "./CollectionList";
import CollectionMiddleView from "./CollectionMiddleView";
import CollectionItemFullScreen from "./CollectionItemFullScreen";
import { Modal } from "antd";
import ShareAsset from "../shareAsset/ShareAsset";
// import EditAsset from "../assets-edit/EditAsset";
import {
  unsetSelectEditAsset,
  unsetSelectShareAsset,
  deactivateMutipleSelectFunctions
} from "../../actions/ClientAction";
import { navigatePublicSharedFolder } from "../../actions/AssetsPublicSharedAction";
import CollectionMultipleFunction from "./CollectionMultipleFunction";
import { KEY_CODE_ESC, getWithDrawer, sendNotification } from "../../utils";
import {
  setSelectedFolderExplore,
  setkeyboardEnabled
} from "../../actions/AppAction";
import BunkeyAPI from "../../api/BunkeyAPI";
import EmptyCollection from "./EmptyCollection";
import "./CollectionBody.css";
import { updateModalVisibility } from "../../actions/MultiselectAction";
import MultiShareModal from "../multi-selector-header-options/MultiShareModal";
import MultiDeleteModal from "../multi-selector-header-options/MultiDeleteModal";
import MultiMoveModal from "../multi-selector-header-options/MultiMoveModal";
import RenameAsset from "../assets-rename/RenameAsset";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spin } from "antd";
import { scrollRoot } from "../../actions/AssetsRootAction";
import { scrollExplore } from "../../actions/AssetsExploreAction";
import { scrollSearch } from "../../actions/SearchAction";
import MoveAsset from "../assets-move/MoveAsset";
import CloseIcon from "../../assets/fi_x-circle.svg";

export class CollectionBody extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isHover: false,
      indice: null,
      visibleDrawerShare: false,
      canMove: false,
      canEdit: false,
      dataVerticalBack: []
    };
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyPressClose, {
      once: false
    });
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyPressClose, {
      once: false
    });
  }

  handleItemSelected = (e, from, indice, item) => {
    const { data, verticalCount, horizontalCount } = this.props;
    const maxItems = from === "vertical" ? verticalCount : horizontalCount;
    let exist = false;
    let count = 0;
    const dataToRender = data.map((r, k) => {
      let i = k + 1;
      if (count >= maxItems) {
        count = 1;
        exist = false;
      } else {
        count++;
      }

      if (!exist) exist = `${from}-${i}` === indice;

      return {
        ...r,
        drawMiddleView:
          (exist && maxItems === count) || (exist && i === data.length)
      };
    });
    this.setState({
      data: dataToRender,
      item: {
        object: item,
        indice: indice,
        positionY: e.clientX - 10
      }
    });
  };

  handleOnClickExplore = (folderselect, foldername) => {
    const { keyCollection, webToken, password } = this.props;
    this.props.setSelectedFolderExplore(folderselect);
    if (keyCollection !== "assetsPublicShared")
      this.props.history.push(`/home/explore/${folderselect}`);
    else {
      this.props.navigatePublicSharedFolder(
        webToken,
        folderselect,
        foldername,
        password
      );
    }
  };

  handleOnMouseEnter = indice => {
    this.setState({
      isHover: true,
      indice
    });
  };

  handleOnMouseLeave = indice => {
    this.setState({
      isHover: false,
      indice
    });
  };

  handleDeactivateOptions = () => {
    const { keyCollection } = this.props;
    this.props.deactivateMutipleSelectFunctions(keyCollection);
  };

  handleKeyPressClose = e => {
    const { keyCollection } = this.props;

    //TO DO: Debe se mejorado y revisado por Verioska Ramirez
    switch (e.keyCode) {
      case KEY_CODE_ESC:
        this.props.unsetSelectShareAsset(keyCollection);
        this.props.unsetSelectEditAsset(keyCollection);
        this.props.setkeyboardEnabled(false);
        break;
      default:
        break;
    }
  };

  convertionFolder = id => {
    const { intl } = this.props;
    BunkeyAPI({
      url: `/convertinators/readFolder`,
      method: "POST",
      data: { id }
    })
      .then(resp => {
        if (resp.status === 201)
          sendNotification(
            "success",
            intl,
            intl.formatMessage({ id: "convetinator_force_conversion_success" })
          );
        else
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "error_message" })
          );
      })
      .catch(e => {
        console.log("err: ", e);
        sendNotification(
          "error",
          intl,
          intl.formatMessage({ id: "error_message" })
        );
      });
  };

  setFlickityRef = carruselRef => {
    this.flkty = carruselRef;
    this.flkty.on("dragStart", () => {
      this.flkty.slider.childNodes.forEach(
        slide => (slide.style.pointerEvents = "none")
      );
    });
    this.flkty.on("dragEnd", () => {
      this.flkty.slider.childNodes.forEach(
        slide => (slide.style.pointerEvents = "all")
      );
    });
  };

  handlerSelectFlickity = index => {
    this.flkty.select(index);
  };
  render() {
    const {
      activeView,
      intl,
      keyCollection,
      data,
      editAssetTab,
      itemSelected,
      itemEditSelected,
      itemExpandSelected,
      itemShareSelected,
      selectedFiles,
      activateMultiOptions,
      pageScrolling,
      isLoadingScroll
    } = this.props;
    const {
      showModalMultiShare,
      showModalMultiDelete,
      showModalMultiMove
    } = selectedFiles;

    const { isHover, indice } = this.state;
    const isBunker =
      itemShareSelected &&
      (itemShareSelected.type === "folder" ||
        itemShareSelected.type === "bunker");
    const prefix = isBunker ? "" : "_file";
    return (
      <React.Fragment>
        <div className="assets-wrapper wrapper-home">
          {/*minHeight:'250px'*/}
          <div
            className="container css-color-bunkers"
            id={
              activeView === "vertical"
                ? "scrollableDivVertical"
                : activeView === "list"
                ? "scrollableDivList"
                : null
            }
            style={{
              overflow: "auto",
              overflowX: "hidden",
              height: "auto",
              maxHeight: "1200px",
              scrollbarTrackColor: "white",
              marginBottom: "5px"
            }}
          >
            {data.length === 0 && (
              <EmptyCollection keyCollection={keyCollection} />
            )}
            {/* {activeView === 'horizontal' && <React.Fragment> */}
            {data.length !== 0 && activeView === "horizontal" && (
              <React.Fragment>
                <CollectionHorizontal
                  keyCollection={keyCollection}
                  isHover={isHover}
                  indice={indice}
                  convertionFolder={this.convertionFolder}
                  handleOnClickExplore={this.handleOnClickExplore}
                  handleOnMouseEnter={this.handleOnMouseEnter}
                  handleOnMouseLeave={this.handleOnMouseLeave}
                  setFlickityRef={this.setFlickityRef}
                  handlerSelectFlickity={this.handlerSelectFlickity}
                  itemSelected={itemSelected}
                />
                {itemSelected && <div style={{ marginTop: "15px" }}></div>}
                {itemSelected && (
                  <CollectionMiddleView
                    parent={this}
                    from={`horizontal`}
                    keyCollection={keyCollection}
                    handlerSelectFlickity={this.handlerSelectFlickity}
                  />
                )}
              </React.Fragment>
            )}
            {/* {activeView === 'vertical' && <CollectionVertical */}
            {data.length !== 0 && activeView === "vertical" && (
              <React.Fragment>
                <InfiniteScroll
                  dataLength={data.length}
                  next={() => {
                    if (data.length >= 30) {
                      switch (keyCollection) {
                        case "assetsRoot":
                          const pageRoot = pageScrolling ? pageScrolling : 1;
                          this.props.scrollRoot(true, pageRoot + 1);
                          break;
                        case "assetsLastUploads":
                        case "assetsShared":
                          break;
                        case "assetsFavorites":
                          break;
                        case "assetsExplore":
                          const pageExplore = pageScrolling ? pageScrolling : 1;
                          this.props.scrollExplore(true, pageExplore + 1);
                          break;
                        case "searcher":
                          const pageSearcher = pageScrolling
                            ? pageScrolling
                            : 1;
                          this.props.scrollSearch(true, pageSearcher + 1);
                          break;
                        case "assetsPublicShared":
                          break;
                        default:
                          break;
                      }
                    }
                  }}
                  hasMore={true}
                  loader={
                    isLoadingScroll && (
                      <Spin
                        style={{ width: "100%" }}
                        spinning={isLoadingScroll}
                      />
                    )
                  }
                  scrollableTarget="scrollableDivVertical"
                >
                  <CollectionVertical
                    keyCollection={keyCollection}
                    isHover={isHover}
                    from={`vertical`}
                    indice={indice}
                    convertionFolder={this.convertionFolder}
                    handleOnClickExplore={this.handleOnClickExplore}
                    handleOnMouseEnter={this.handleOnMouseEnter}
                    handleOnMouseLeave={this.handleOnMouseLeave}
                  />
                </InfiniteScroll>
              </React.Fragment>
            )}

            {/* {activeView === 'multiple' && <CollectionVertical */}
            {data.length !== 0 && activeView === "multiple" && (
              <CollectionVertical
                keyCollection={keyCollection}
                isHover={isHover}
                indice={indice}
                convertionFolder={this.convertionFolder}
                handleOnClickExplore={this.handleOnClickExplore}
                handleOnMouseEnter={this.handleOnMouseEnter}
                handleOnMouseLeave={this.handleOnMouseLeave}
              />
            )}
            {/* {activeView === 'list' && <CollectionList */}
            {data.length !== 0 && activeView === "list" && (
              <React.Fragment>
                <InfiniteScroll
                  dataLength={data.length}
                  next={() => {
                    if (data.length >= 30) {
                      switch (keyCollection) {
                        case "assetsRoot":
                          const pageRoot = pageScrolling ? pageScrolling : 1;
                          this.props.scrollRoot(true, pageRoot + 1);
                          break;
                        case "assetsLastUploads":
                        case "assetsShared":
                          break;
                        case "assetsFavorites":
                          break;
                        case "assetsExplore":
                          const pageExplore = pageScrolling ? pageScrolling : 1;
                          this.props.scrollExplore(true, pageExplore + 1);
                          break;
                        case "searcher":
                          const pageSearcher = pageScrolling
                            ? pageScrolling
                            : 1;
                          this.props.scrollSearch(true, pageSearcher + 1);
                          break;
                        case "assetsPublicShared":
                          break;
                        default:
                          break;
                      }
                    }
                  }}
                  hasMore={true}
                  loader={
                    isLoadingScroll && (
                      <Spin
                        style={{ width: "100%" }}
                        spinning={isLoadingScroll}
                      />
                    )
                  }
                  scrollableTarget="scrollableDivList"
                >
                  <CollectionList
                    from={`list`}
                    keyCollection={keyCollection}
                    isHover={isHover}
                    indice={indice}
                    convertionFolder={this.convertionFolder}
                    handleOnClickExplore={this.handleOnClickExplore}
                    handleOnMouseEnter={this.handleOnMouseEnter}
                    handleOnMouseLeave={this.handleOnMouseLeave}
                  />
                </InfiniteScroll>
              </React.Fragment>
            )}
            {itemExpandSelected && (
              <CollectionItemFullScreen keyCollection={keyCollection} />
            )}
            {itemShareSelected && itemShareSelected.isShareSelected && (
              <Modal
                placement="right"
                width={getWithDrawer()}
                closable={true}
                footer={null}
                onCancel={() => this.props.unsetSelectShareAsset(keyCollection)}
                onClose={() => this.props.unsetSelectShareAsset(keyCollection)}
                visible={itemShareSelected && itemShareSelected.isShareSelected}
                keyboard={true}
                closeIcon={<img src={CloseIcon} alt={"icon close"} />}
                centered
              >
                <div className="share-modal-title">
                  {/* {intl.formatMessage({ id: "shared_share" })} */}
                  {intl.formatMessage({ id: `share-modal-title${prefix}` })}
                </div>
                <ShareAsset keyCollection={keyCollection} />
              </Modal>
            )}

            {/* Drawer Editar Asset */}
            {itemEditSelected && itemEditSelected.isEditSelected && (
              <Modal
                placement="right"
                footer={null}
                width={getWithDrawer()}
                closable={true}
                destroyOnClose={true}
                onClose={() => {
                  this.props.unsetSelectEditAsset(keyCollection);
                  this.props.setkeyboardEnabled(false);
                }}
                onCancel={() => {
                  this.props.unsetSelectEditAsset(keyCollection);
                  this.props.setkeyboardEnabled(false);
                }}
                visible={itemEditSelected && itemEditSelected.isEditSelected}
                keyboard={true}
                centered
                closeIcon={<img src={CloseIcon} alt={"icon close"} />}
                className="move-modal"
              >
                <div className="move-modal-title">
                  {intl.formatMessage(
                    editAssetTab === "edit"
                      ? { id: "rename_asset" }
                      : { id: "move_asset" }
                  )}
                </div>
                {editAssetTab === "edit" && (
                  <RenameAsset
                    keyCollection={keyCollection}
                    defaultTab={editAssetTab}
                    type={"asset"}
                  />
                )}
                {editAssetTab === "move" && (
                  <MoveAsset
                    keyCollection={keyCollection}
                    defaultTab={editAssetTab}
                    type={"asset"}
                  />
                )}
              </Modal>
            )}

            <Modal
              title="Acciones selección múltiple"
              placement="right"
              width={getWithDrawer()}
              footer={null}
              closable={true}
              onCancel={this.handleDeactivateOptions}
              onClose={this.handleDeactivateOptions}
              visible={activateMultiOptions}
              keyboard={true}
            >
              <CollectionMultipleFunction keyCollection={keyCollection} />
            </Modal>
            {showModalMultiShare && (
              <MultiShareModal
                showModal={showModalMultiShare}
                handleHiddenModal={() =>
                  this.props.updateModalVisibility({
                    showModalMultiShare: false
                  })
                }
                keyCollection={keyCollection}
              />
            )}
            {showModalMultiDelete && (
              <MultiDeleteModal
                showModal={showModalMultiDelete}
                handleHiddenModal={() =>
                  this.props.updateModalVisibility({
                    showModalMultiDelete: false
                  })
                }
                isFetching={false}
              />
            )}
            {showModalMultiMove && (
              <MultiMoveModal
                showModal={showModalMultiMove}
                handleHiddenModal={() =>
                  this.props.updateModalVisibility({
                    showModalMultiMove: false
                  })
                }
                keyCollection={keyCollection}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps;
  let object;

  switch (keyCollection) {
    case "assetsRoot":
      object = {
        isFetching: state.assetsRoot.isFetching,
        data: state.assetsRoot.data,
        itemShareSelected: state.assetsRoot.data.find(r => r.isShareSelected),
        itemEditSelected: state.assetsRoot.data.find(r => r.isEditSelected),
        editAssetTab: state.assetsRoot.editAssetTab,
        itemSelected: state.assetsRoot.data.find(r => r.isSelected),
        folderselect: state.assetsRoot.folderselect,
        activateMultiOptions: state.assetsRoot.activateMultiOptions,
        error: state.assetsRoot.error,
        activeView: state.assetsRoot.activeView,
        pageScrolling: state.assetsRoot.pageScrolling,
        isLoadingScroll: state.assetsRoot.isLoadingScroll
      };
      break;
    case "assetsLastUploads":
      object = {
        isFetching: state.assetsLastUploads.isFetching,
        itemShareSelected: state.assetsLastUploads.data.find(
          r => r.isShareSelected
        ),
        itemEditSelected: state.assetsLastUploads.data.find(
          r => r.isEditSelected
        ),
        itemExpandSelected: state.assetsLastUploads.data.find(
          r => r.isExpandSelected
        ),
        editAssetTab: state.assetsLastUploads.editAssetTab,
        data: state.assetsLastUploads.data,
        itemSelected: state.assetsLastUploads.data.find(r => r.isSelected),
        activateMultiOptions: state.assetsLastUploads.activateMultiOptions,
        folderselect: state.assetsLastUploads.folderselect,
        error: state.assetsLastUploads.error,
        activeView: state.assetsLastUploads.activeView
      };
      break;
    case "assetsShared":
      object = {
        isFetching: state.assetsShared.isFetching,
        data: state.assetsShared.data,
        itemShareSelected: state.assetsShared.data.find(r => r.isShareSelected),
        itemEditSelected: state.assetsShared.data.find(r => r.isEditSelected),
        itemExpandSelected: state.assetsShared.data.find(
          r => r.isExpandSelected
        ),
        editAssetTab: state.assetsShared.editAssetTab,
        itemSelected: state.assetsShared.data.find(r => r.isSelected),
        activateMultiOptions: state.assetsShared.activateMultiOptions,
        folderselect: state.assetsShared.folderselect,
        error: state.assetsShared.error,
        activeView: state.assetsShared.activeView
      };
      break;
    case "assetsFavorites":
      object = {
        isFetching: state.assetsFavorites.isFetching,
        data: state.assetsFavorites.data,
        itemShareSelected: state.assetsFavorites.data.find(
          r => r.isShareSelected
        ),
        itemEditSelected: state.assetsFavorites.data.find(
          r => r.isEditSelected
        ),
        itemExpandSelected: state.assetsFavorites.data.find(
          r => r.isExpandSelected
        ),
        editAssetTab: state.assetsFavorites.editAssetTab,
        itemSelected: state.assetsFavorites.data.find(r => r.isSelected),
        activateMultiOptions: state.assetsFavorites.activateMultiOptions,
        folderselect: state.assetsFavorites.folderselect,
        error: state.assetsFavorites.error,
        activeView: state.assetsFavorites.activeView
      };
      break;
    case "assetsExplore":
      object = {
        isFetching: state.assetsExplore.isFetching,
        data: state.assetsExplore.data,
        itemShareSelected: state.assetsExplore.data.find(
          r => r.isShareSelected
        ),
        itemEditSelected: state.assetsExplore.data.find(r => r.isEditSelected),
        itemExpandSelected: state.assetsExplore.data.find(
          r => r.isExpandSelected
        ),
        editAssetTab: state.assetsExplore.editAssetTab,
        itemSelected: state.assetsExplore.data.find(r => r.isSelected),
        activateMultiOptions: state.assetsExplore.activateMultiOptions,
        folderselect: state.assetsExplore.folderselect,
        error: state.assetsExplore.error,
        activeView: state.assetsExplore.activeView,
        pageScrolling: state.assetsExplore.pageScrolling,
        isLoadingScroll: state.assetsExplore.isLoadingScroll
      };
      break;
    case "searcher":
      object = {
        isFetching: state.searcher.isFetching,
        data: state.searcher.data,
        itemShareSelected: state.searcher.data.find(r => r.isShareSelected),
        itemEditSelected: state.searcher.data.find(r => r.isEditSelected),
        itemExpandSelected: state.searcher.data.find(r => r.isExpandSelected),
        editAssetTab: state.searcher.editAssetTab,
        itemSelected: state.searcher.data.find(r => r.isSelected),
        activateMultiOptions: state.searcher.activateMultiOptions,
        folderselect: state.searcher.folderselect,
        error: state.searcher.error,
        activeView: state.searcher.activeView,
        pageScrolling: state.searcher.pageScrolling,
        isLoadingScroll: state.searcher.isLoadingScroll
      };
      break;
    case "assetsPublicShared":
      object = {
        isFetching: state.assetsPublicShared.isFetching,
        data: state.assetsPublicShared.data,
        folderselect: state.assetsPublicShared.folderselect,
        itemExpandSelected: state.assetsPublicShared.data.find(
          r => r.isExpandSelected
        ),
        itemSelected: state.assetsPublicShared.data.find(r => r.isSelected),
        error: state.assetsPublicShared.error,
        activeView: state.assetsPublicShared.activeView,
        webToken: state.assetsPublicShared.webToken
      };
      break;

    default:
      object = {};
      break;
  }
  return {
    ...object,
    verticalCount: state.app.verticalCount,
    horizontalCount: state.app.horizontalCount,
    width: state.app.width,
    selectedFiles: state.selectedFiles,
    user: state.authUser.user,
    matrix: state.group.matrix,
    newMatrix: state.group.newMatrix
  };
};

const mapDispatchToProps = {
  unsetSelectEditAsset,
  unsetSelectShareAsset,
  navigatePublicSharedFolder,
  deactivateMutipleSelectFunctions,
  setkeyboardEnabled,
  updateModalVisibility,
  setSelectedFolderExplore,
  scrollRoot,
  scrollExplore,
  scrollSearch
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionBody))
);
